var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLanguageProficiency(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 106,
    height: 106,
    viewBox: "0 0 106 106",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9166",
    "data-name": "Group 9166",
    transform: "translate(0 0.315)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9135",
    "data-name": "Group 9135",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1647",
    "data-name": "Ellipse 1647",
    cx: 53,
    cy: 53,
    r: 53,
    transform: "translate(0 -0.315)",
    fill: "#ff6565"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_9165",
    "data-name": "Group 9165",
    transform: "translate(25.14 24.101)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9164",
    "data-name": "Group 9164",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19705",
    "data-name": "Path 19705",
    d: "M55.594,0H29.124A1.654,1.654,0,0,0,27.47,1.654V17.867H2.654A1.654,1.654,0,0,0,1,19.522V54.815a1.654,1.654,0,0,0,2.824,1.17l6.133-6.133H29.124A1.654,1.654,0,0,0,30.779,48.2V31.984H48.292l6.133,6.133a1.654,1.654,0,0,0,2.824-1.17V1.654A1.654,1.654,0,0,0,55.594,0ZM27.47,46.543H9.272a1.654,1.654,0,0,0-1.17.485L4.309,50.821V21.176H27.47ZM53.94,32.954,50.146,29.16a1.654,1.654,0,0,0-1.17-.485h-18.2V3.309H53.94Z",
    transform: "translate(-1)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19706",
    "data-name": "Path 19706",
    d: "M297.736,68.1h1.27a13.267,13.267,0,0,0,3.362,7.222,9.773,9.773,0,0,1-4.054.878,1.736,1.736,0,1,0,0,3.471,13.226,13.226,0,0,0,6.943-1.959,13.227,13.227,0,0,0,6.943,1.959,1.736,1.736,0,1,0,0-3.471,9.774,9.774,0,0,1-4.054-.878,13.266,13.266,0,0,0,3.362-7.222h1.27a1.736,1.736,0,1,0,0-3.471h-5.785V61.736a1.736,1.736,0,1,0-3.471,0v2.893h-5.786a1.736,1.736,0,1,0,0,3.471Zm7.521,5.224A9.823,9.823,0,0,1,302.52,68.1h5.473a9.82,9.82,0,0,1-2.736,5.224Z",
    transform: "translate(-264.629 -53.057)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19707",
    "data-name": "Path 19707",
    d: "M75.852,223.35l-.019-.048a2.1,2.1,0,0,0-1.945-1.3h0a2.1,2.1,0,0,0-1.944,1.307l-.016.039-6.083,15.971a1.736,1.736,0,0,0,3.244,1.235l1.089-2.86h7.377l1.077,2.855a1.736,1.736,0,0,0,3.248-1.226ZM71.5,234.222l2.384-6.258,2.362,6.258Z",
    transform: "translate(-58.24 -198.113)",
    fill: "#fff"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLanguageProficiency);
export default __webpack_public_path__ + "static/media/LanguageProficiency.3465598fca5c09834ad424108acb341e.svg";
export { ForwardRef as ReactComponent };